module.exports = [
	{
		"country": "United Arab Emirates",
		"region": "Middle East",
		"city": "Dubai",
		"per_capita": 25519,
		"spending": 0.14,
		"households": 0.92,
		"gva": 0.23,
		"report_link": "http://www.euromonitor.com/dubai-city-review/report"
	},
	{
		"country": "Bahrain",
		"region": "Middle East",
		"city": "Manama",
		"per_capita": 15167,
		"spending": 0.13,
		"households": 0.82,
		"gva": 0.22,
		"report_link": "http://www.euromonitor.com/manama-city-review/report"
	},
	{
		"country": "Uraguay",
		"region": "Latin America",
		"city": "Montevideo",
		"per_capita": 12779,
		"spending": 0.17,
		"households": 0.67,
		"gva": 0.32,
		"report_link": "http://www.euromonitor.com/montevideo-city-review/report"
	},
	{
		"country": "Chile",
		"region": "Latin America",
		"city": "Santiago",
		"per_capita": 9948,
		"spending": 0.13,
		"households": 0.72,
		"gva": 0.44,
		"report_link": "http://www.euromonitor.com/santiago-city-review/report"
	},
	{
		"country": "Argentina",
		"region": "Latin America",
		"city": "Buenos Aires",
		"per_capita": 9759,
		"spending": 0.19,
		"households": 0.59,
		"gva": 0.23,
		"report_link": "http://www.euromonitor.com/buenos-aires-city-review/report"
	},
	{
		"country": "Brazil",
		"region": "Latin America",
		"city": "São Paulo",
		"per_capita": 8853,
		"spending": 0.14,
		"households": 0.7,
		"gva": 0.23,
		"report_link": "http://www.euromonitor.com/sao-paulo-city-review/report"
	},
	{
		"country": "Costa Rica",
		"region": "Latin America",
		"city": "San Jose",
		"per_capita": 8394,
		"spending": 0.19,
		"households": 0.69,
		"gva": 0.21,
		"report_link": "http://www.euromonitor.com/san-jose-city-review/report"
	},
	{
		"country": "China",
		"region": "Asia Pacific",
		"city": "Shenzhen",
		"per_capita": 12112,
		"spending": 0.21,
		"households": 0.83,
		"gva": 0.29,
		"report_link": "http://www.euromonitor.com/shenzhen-city-review/report"
	},
	{
		"country": "China",
		"region": "Asia Pacific",
		"city": "Shanghai",
		"per_capita": 11173,
		"spending": 0.22,
		"households": 0.84,
		"gva": 0.29,
		"report_link": "http://www.euromonitor.com/shanghai-city-review/report"
	},
	{
		"country": "Hong Kong, China?",
		"region": "Asia Pacific",
		"city": "Guangzhou",
		"per_capita": 10365,
		"spending": 0.21,
		"households": 0.79,
		"gva": 0.28,
		"report_link": "http://www.euromonitor.com/guangzhou-city-review/report"
	},
	{
		"country": "China",
		"region": "Asia Pacific",
		"city": "Beijing",
		"per_capita": 9891,
		"spending": 0.19,
		"households": 0.86,
		"gva": 0.39,
		"report_link": "http://www.euromonitor.com/beijing-city-review/report"
	},
	{
		"country": "Malaysia",
		"region": "Asia Pacific",
		"city": "Kuala Lampur",
		"per_capita": 9087,
		"spending": 0.19,
		"households": 0.79,
		"gva": 0.21,
		"report_link": "http://www.euromonitor.com/kuala-lumpur-city-review/report"
	},
	{
		"country": "China",
		"region": "Asia Pacific",
		"city": "Tianjin",
		"per_capita": 7570,
		"spending": 0.23,
		"households": 0.75,
		"gva": 0.19,
		"report_link": "http://www.euromonitor.com/tianjin-city-review/report"
	},
	{
		"country": "Turkey",
		"region": "Other Regions",
		"city": "Ankara",
		"per_capita": 9572,
		"spending": 0.19,
		"households": 0.76,
		"gva": 0.28,
		"report_link": "http://www.euromonitor.com/ankara-city-review/report"
	},
	{
		"country": "Turkey",
		"region": "Other Regions",
		"city": "Istanbul",
		"per_capita": 8741,
		"spending": 0.19,
		"households": 0.78,
		"gva": 0.31,
		"report_link": "http://www.euromonitor.com/istanbul-city-review/report"
	},
	{
		"country": "Poland",
		"region": "Other Regions",
		"city": "Warsaw",
		"per_capita": 8580,
		"spending": 0.16,
		"households": 0.78,
		"gva": 0.32,
		"report_link": "http://www.euromonitor.com/warsaw-city-review/report"
	},
	{
		"country": "Hungary",
		"region": "Other Regions",
		"city": "Budapest",
		"per_capita": 7994,
		"spending": 0.15,
		"households": 0.88,
		"gva": 0.3,
		"report_link": "http://www.euromonitor.com/budapest-city-review/report"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/app/services/data/future-cities-data.json
// module id = 89
// module chunks = 0